import { genElZirvuImage } from "../../../../components/utils/EditorDialogElementGenerator";
import { getFotoFolderName } from "../../utils/editorHelpers";

// Photo of a checklist row. It is never shown: pressing "Berangkat" / "Pulang" in the row popover presses the
// "Take Photo" button of this genElZirvuImage (see useEditorNote.handleOnClickFoto).
// genElZirvuImage uploads the photo to the file manager and gives back its url; that url (or "" when the photo
// is cleared) is handed to onChangeFoto, which puts it on the row (saved with the Save button of the card).
//   fotoTargetRef: { type, row } of the photo that is being taken
const EditorFotoUploader = ({
  uploaderRef,
  fotoTargetRef,
  headerData,
  pengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  onChangeFoto,
}) => {
  // folder of the file manager the row photos go to, like the pengecekan photos before
  const folderName = getFotoFolderName(headerData);

  const elFoto = genElZirvuImage({
    field: "gambar",
    name: "Foto",
    folderName,
    data: { gambar: null },
    setData: (newData) => {
      const target = fotoTargetRef.current;
      if (!target) return;

      const { type, row } = target;
      const detilList =
        type === "berangkat"
          ? pengecekanBerangkatDetilData
          : pengecekanKembaliDetilData;
      const detil = detilList.find((el) => el.keterangan === row.keterangan);
      if (!detil) return;

      const current = { gambar: detil.gambar };
      const resolved = typeof newData === "function" ? newData(current) : newData;
      onChangeFoto({ type, detil, gambar: resolved.gambar });
    },
    error: {},
  });

  return (
    <div ref={uploaderRef} style={{ display: "none" }}>
      {elFoto}
    </div>
  );
};

export default EditorFotoUploader;
